import { http } from '@/store/api/http-common';

const saveAssetTransfer = async (params) => {
    try {
        const { data } = await http.post('asset-transfer', params);
        return data || null;
    } catch (error) {
        return Promise.reject(error);
    }
};


const getAssetTransferById = async (id) => {
    try {
        const { data } = await http.get(`asset-transfer/${id}`);
        return data || null;
    } catch (error) {
        return Promise.reject(error);
    }
};

const getAssetTransfer = async (params) => {
    try {
        const { data } = await http.get('asset-transfer', { params });
        return data || null;
    } catch (error) {
        return Promise.reject(error);
    }
};

export {
    saveAssetTransfer,
    getAssetTransferById,
    getAssetTransfer
};
